import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useApp } from "../context/AppContext";
import { uid } from "../utils/helpers";

function toSlug(text) {
  return (text || "").toLowerCase().replace(/[^a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").slice(0, 80);
}

export default function StructureView() {
  const { proj, activeId, getStore, setStore, dataRef, projects, setProjects, apiFetch,
    saveClusters, saveContent, saveStructure, saveSemClusters, saveLinks,
    flash, setView, view, dark, setDark, t, card, inp, btnP, btnG, btnSm, stitle, muted, th, td,
    userRole, currentUser, loadProjectData, openP, infoId, setInfoId, setActiveId } = useApp();
  const store = getStore(activeId);
  // ── Зміна URL сторінки (каскадне перейменування) ──
  const rnStrip = (u) => String(u || "").replace(/https?:\/\/[^/]+/, "") || "/";
  const [rn, setRn] = useState(null);
  const openRename = (url) => setRn({ oldUrl: url, newUrl: url, mode: "single", busy: false, preview: null, republish: true });
  const rnPreview = async () => {
    setRn(r => ({ ...r, busy: true }));
    try { const res = await apiFetch(`/api/projects/${activeId}/rename-url`, { method: "POST", body: JSON.stringify({ oldUrl: rn.oldUrl, newUrl: rn.newUrl, mode: rn.mode, dryRun: true }) }); const d = await res.json(); setRn(r => ({ ...r, busy: false, preview: d.report || d })); }
    catch (e) { setRn(r => ({ ...r, busy: false })); flash("Помилка: " + e.message); }
  };
  const rnApply = async () => {
    setRn(r => ({ ...r, busy: true }));
    try {
      const res = await apiFetch(`/api/projects/${activeId}/rename-url`, { method: "POST", body: JSON.stringify({ oldUrl: rn.oldUrl, newUrl: rn.newUrl, mode: rn.mode, republish: rn.republish }) });
      const d = await res.json(); if (!res.ok) throw new Error(d.error || "err");
      if (rn.republish) { try { await apiFetch(`/api/projects/${activeId}/seo-texts/republish`, { method: "POST" }); } catch {} }
      flash("URL змінено каскадно ✓" + (rn.republish ? " (переопубліковано)" : "")); setRn(null); if (loadProjectData) loadProjectData(activeId);
      if (hist) loadHist();
    } catch (e) { setRn(r => ({ ...r, busy: false })); flash("Помилка: " + e.message); }
  };
  // ── Історія змін URL (журнал перейменувань) ──
  const [hist, setHist] = useState(null); // null = закрито, масив = відкрито
  const [histBusy, setHistBusy] = useState(false);
  const loadHist = async () => {
    setHistBusy(true);
    try { const res = await apiFetch(`/api/projects/${activeId}/rename-url/log`); const d = await res.json(); setHist(d.log || []); }
    catch (e) { setHist([]); flash("Помилка: " + e.message); }
    finally { setHistBusy(false); }
  };
  const [tree, setTree] = useState(() => store.structure || null);
  const [error, setError] = useState("");
  const [expMap, setExpMap] = useState(() => {
    const t = store.structure;
    if (!t || !t.children) return {};
    const ae = {};
    t.children.forEach((c, i) => {
      ae[String(i)] = true;
      (c.children || []).forEach((_, j) => { ae[i + "/" + j] = true; });
    });
    return ae;
  });
  const [stats, setStats] = useState(() => {
    const t = store.structure;
    if (!t || !t.children) return null;
    let tot = 0, md = 0;
    const wk = (ns, d) => { (ns || []).forEach(n => { tot++; if (d > md) md = d; wk(n.children, d + 1); }); };
    wk(t.children, 0);
    return { total: tot, top: t.children.length, depth: md + 1 };
  });
  const [addPath, setAddPath] = useState(null);
  const [addText, setAddText] = useState("");
  const [pasteText, setPasteText] = useState("");
  const [showPaste, setShowPaste] = useState(false);
  const [ver, setVer] = useState(0);
  const [kwOpen, setKwOpen] = useState({});
  const fRef = useRef();

  // Save structure to DB on changes
  useEffect(() => { if (ver > 0 && tree && activeId) { setStore(activeId, { ...getStore(activeId), structure: tree }); saveStructure(activeId, tree); } }, [ver]);


  const gatherPaths = (nodes, pfx) => {
    const o = {};
    (nodes || []).forEach((n, i) => {
      const p = pfx !== undefined ? pfx + "/" + i : String(i);
      if (n.children?.length) { o[p] = true; Object.assign(o, gatherPaths(n.children, p)); }
    });
    return o;
  };
  const doExpandAll = () => { if (tree) setExpMap(gatherPaths(tree.children, undefined)); };
  const doCollapseAll = () => setExpMap({});
  const doToggle = p => setExpMap(prev => ({ ...prev, [p]: !prev[p] }));

  // Parse CSV: name at column N = level N, URL at column N+1
  const parseFile = (text) => {
    const lines = text.trim().split(/\r?\n/).filter(l => l.trim());
    if (!lines.length) return null;

    // Detect separator from first 5 non-empty lines (not just first)
    const sepSample = lines.slice(0, 5).join("\n");
    const sep = sepSample.includes("\t") ? "\t" : ",";

    // Parse CSV with quote handling
    const parseRow = (line) => {
      const cells = []; let c = ""; let q = false;
      for (const ch of line) {
        if (ch === '"') { q = !q; continue; }
        if (ch === sep && !q) { cells.push(c.trim()); c = ""; continue; }
        c += ch;
      }
      cells.push(c.trim());
      return cells;
    };

    const rows = lines.map(parseRow);
    const maxCols = rows.reduce((m, r) => Math.max(m, r.length), 0);

    const root = { name: "Сайт", url: "", children: [] };
    const lastAtLevel = {};

    for (const row of rows) {
      // Find URL anywhere in the row (not just next cell — Excel often has URL in a fixed last column)
      const rowUrl = row.map(c => (c || "").trim()).find(c => c.startsWith("http")) || "";

      // Find all name cells (non-empty, non-URL)
      const entries = [];
      for (let j = 0; j < row.length; j++) {
        const cell = (row[j] || "").replace(/\r/g, "").trim();
        if (!cell || cell.startsWith("http")) continue;
        // Level = column index; URL = first http cell in row
        entries.push({ level: j, name: cell, url: rowUrl });
      }

      for (const entry of entries) {
        const { level, name, url } = entry;
        // Find parent: exact level-1, or walk up to find closest ancestor
        let parent = level === 0 ? root : lastAtLevel[level - 1];
        if (!parent) {
          for (let lv = level - 1; lv >= 0; lv--) {
            if (lastAtLevel[lv]) { parent = lastAtLevel[lv]; break; }
          }
        }
        if (!parent) parent = root; // fallback: add to root instead of skipping

        const ex = parent.children.find(c => c.name === name && (!c.url || !url || c.url === url));
        if (ex) { lastAtLevel[level] = ex; if (url && !ex.url) ex.url = url; }
        else { const nd = { name, url, children: [] }; parent.children.push(nd); lastAtLevel[level] = nd; }
        // Clear deeper levels
        for (let k = level + 1; k <= maxCols; k++) delete lastAtLevel[k];
      }
    }

    let tot = 0, md = 0;
    const wk = (ns, d) => { (ns || []).forEach(n => { tot++; if (d > md) md = d; wk(n.children, d + 1); }); };
    wk(root.children, 0);
    return { tree: root, stats: { total: tot, top: root.children.length, depth: md + 1 } };
  };

  const recalcStats = (t) => {
    let tot = 0, md = 0;
    const wk = (ns, d) => { (ns || []).forEach(n => { tot++; if (d > md) md = d; wk(n.children, d + 1); }); };
    wk(t.children, 0);
    setStats({ total: tot, top: t.children.length, depth: md + 1 });
  };

  const handleFile = (file) => {
    setError("");
    const r = new FileReader();
    r.onload = ev => {
      try {
        const res = parseFile(ev.target.result);
        if (!res || !res.tree.children.length) { setError("Не удалось распарсить файл"); return; }
        setTree(res.tree); setStats(res.stats);
        // Auto-expand first 2 levels
        const ae = {};
        res.tree.children.forEach((c, i) => {
          ae[String(i)] = true;
          (c.children || []).forEach((_, j) => { ae[i + "/" + j] = true; });
        });
        setExpMap(ae); setVer(v => v + 1);
      } catch (e) { setError(e.message); }
    };
    r.readAsText(file);
  };

  const handlePaste = () => {
    if (!pasteText.trim()) return;
    setError("");
    try {
      const res = parseFile(pasteText);
      if (!res || !res.tree.children.length) { setError("Не вдалося розпарсити вставлений текст"); return; }
      setTree(res.tree); setStats(res.stats);
      const ae = {};
      res.tree.children.forEach((c, i) => {
        ae[String(i)] = true;
        (c.children || []).forEach((_, j) => { ae[i + "/" + j] = true; });
      });
      setExpMap(ae); setVer(v => v + 1); setPasteText(""); setShowPaste(false);
    } catch (e) { setError(e.message); }
  };

  // Add children
  const addChildren = () => {
    if (!addPath || !addText.trim() || !tree) return;
    const names = addText.trim().split("\n").map(s => s.trim()).filter(Boolean);
    if (!names.length) return;
    const parts = addPath.split("/").map(Number);
    let node = { children: tree.children };
    for (const idx of parts) { if (!node.children?.[idx]) return; node = node.children[idx]; }
    const base = (node.url || "").replace(/https?:\/\/[^/]+/, "").replace(/\/?$/, "");
    names.forEach(nm => {
      if (node.children.find(c => c.name === nm)) return;
      const slug = toSlug(nm);
      node.children.push({ name: nm, url: base ? base + "/" + slug : "/" + slug, children: [], isNew: true });
    });
    setTree({ ...tree }); recalcStats(tree);
    setExpMap(prev => ({ ...prev, [addPath]: true }));
    setAddPath(null); setAddText(""); setVer(v => v + 1);
    flash(`+${names.length} добавлено`);
  };

  // Export
  const exportCSV = () => {
    if (!tree) return;
    const esc = s => `"${(s || "").replace(/"/g, '""')}"`;
    const rows = [];
    const walk = (ns, depth) => {
      (ns || []).forEach(n => {
        const row = new Array(depth * 2).fill("");
        row.push(esc(n.name)); row.push(esc(n.url));
        if (!n.children?.length) rows.push(row);
        else walk(n.children, depth + 1);
      });
    };
    walk(tree.children, 0);
    const mx = Math.max(...rows.map(r => r.length));
    const csv = rows.map(r => { while (r.length < mx) r.push(""); return r.join(","); }).join("\n");
    const b = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(b); a.download = "structure_expanded.csv"; a.click();
  };

  const exportSuggestionsCSV = () => {
    if (!suggestions || !suggestions.length) return;
    const escape = (v) => {
      const str = String(v == null ? "" : v);
      return /[",\n]/.test(str) ? '"' + str.replace(/"/g, '""') + '"' : str;
    };
    const lines = ["Тип,Розділ-батько,Нова сторінка,Слаг,Ключі,Обґрунтування"];
    suggestions.forEach((sg) => {
      const type = sg.type === "new_section" ? "Новий розділ" : "Розширення";
      const parent = sg.parent_path || "—";
      (sg.new_pages || []).forEach((pg) => {
        const slug = toSlug(pg.name);
        const kws = (pg.keywords || []).join("; ");
        lines.push([type, parent, pg.name, slug, kws, pg.reason || ""].map(escape).join(","));
      });
    });
    const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `structure_suggestions_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  // === AI Expansion Suggestions ===
  const [aiLoading, setAiLoading] = useState(false);
  const [aiProgress, setAiProgress] = useState("");
  const sugKey = activeId ? `metago_struct_suggestions_${activeId}` : null;
  const [suggestions, setSuggestions] = useState(() => {
    try { if (!sugKey) return null; const raw = localStorage.getItem(sugKey); return raw ? JSON.parse(raw) : null; } catch { return null; }
  });
  const [checkedPages, setCheckedPages] = useState(() => {
    try { if (!activeId) return new Set(); const raw = localStorage.getItem(`metago_struct_checked_${activeId}`); return raw ? new Set(JSON.parse(raw)) : new Set(); } catch { return new Set(); }
  }); // "gi-pi" keys
  // Persist suggestions and checked pages per project
  useEffect(() => {
    if (!sugKey) return;
    try { if (suggestions) localStorage.setItem(sugKey, JSON.stringify(suggestions)); else localStorage.removeItem(sugKey); } catch {}
  }, [suggestions, sugKey]);
  useEffect(() => {
    if (!activeId) return;
    try { localStorage.setItem(`metago_struct_checked_${activeId}`, JSON.stringify([...checkedPages])); } catch {}
  }, [checkedPages, activeId]);
  // Reload from storage when active project changes
  useEffect(() => {
    if (!activeId) return;
    try {
      const raw = localStorage.getItem(`metago_struct_suggestions_${activeId}`);
      setSuggestions(raw ? JSON.parse(raw) : null);
      const ch = localStorage.getItem(`metago_struct_checked_${activeId}`);
      setCheckedPages(ch ? new Set(JSON.parse(ch)) : new Set());
    } catch {}
  }, [activeId]);
  const [applyReport, setApplyReport] = useState(null);

  const flattenTree = (nodes, depth = 0, parent = "") => {
    const res = [];
    (nodes || []).forEach(n => {
      const path = parent ? parent + " > " + n.name : n.name;
      res.push({ name: n.name, url: n.url || "", depth, path, childCount: n.children?.length || 0 });
      if (n.children?.length) res.push(...flattenTree(n.children, depth + 1, path));
    });
    return res;
  };

  const suggestExpansions = async () => {
    if (!tree) return;
    const store = getStore(activeId);
    const clusters = store.clusters || [];
    const semClusters = store.semClusters || [];

    setAiLoading(true); setAiProgress("Завантаження GSC..."); setSuggestions(null);

    // 1. Load GSC data
    let gscQueries = [];
    try {
      const gscResp = await apiFetch(`/api/gsc/saved/${activeId}`);
      const gscJson = await gscResp.json();
      if (gscJson.found && gscJson.rows) gscQueries = gscJson.rows;
    } catch {}

    // 2. Load Serpstat domain keywords
    setAiProgress("Завантаження Serpstat...");
    let serpstatKws = [];
    try {
      const sResp = await apiFetch(`/api/projects/${activeId}/serpstat/domain-keywords?limit=300`);
      const sJson = await sResp.json();
      if (Array.isArray(sJson)) serpstatKws = sJson;
      else if (sJson.data && Array.isArray(sJson.data)) serpstatKws = sJson.data;
    } catch {}

    if (!clusters.length && !semClusters.length && !gscQueries.length && !serpstatKws.length) {
      flash("Немає даних: завантажте семантику, підключіть GSC або Serpstat"); setAiLoading(false); setAiProgress(""); return;
    }

    setAiProgress("Підготовка даних...");

    // Flatten tree for prompt
    const treeFlat = flattenTree(tree.children);
    const treeText = treeFlat.map(n => "  ".repeat(n.depth) + n.name + (n.url ? ` (${n.url})` : "") + (n.childCount ? ` [${n.childCount} підстор.]` : "")).join("\n");

    // Current clusters (main semantics from CSV/collection)
    let clusterSection = "";
    if (clusters.length) {
      const topCl = clusters.slice(0, 300).map(c => {
        const kws = (c.keywords || []).slice(0, 5).map(k => typeof k === "string" ? k : k.keyword).join(", ");
        return `${c.url} → ВЧ: "${c.hfKeyword}" (${c.hfFreq}) | ${(c.keywords || []).length} кл.: ${kws}`;
      }).join("\n");
      clusterSection = `\nПОТОЧНА СЕМАНТИКА (кластери по сторінках):\n${topCl}`;
    }

    // SemClusters (legacy format)
    let semSection = "";
    if (semClusters.length && !clusters.length) {
      semSection = "\nСЕМАНТИЧНІ КЛАСТЕРИ:\n" + semClusters.slice(0, 300).map(c =>
        `${c.cluster} (${c.hfFreq}) [${c.keywords.length} кл.]: ${c.keywords.slice(0, 5).map(k => k.keyword).join(", ")}`
      ).join("\n");
    }

    // GSC: aggregate by page
    let gscSection = "";
    if (gscQueries.length) {
      const byPage = {};
      for (const r of gscQueries) {
        if (!byPage[r.page]) byPage[r.page] = [];
        byPage[r.page].push(r);
      }
      const pages = Object.entries(byPage)
        .map(([page, rows]) => ({ page, rows, totalImpr: rows.reduce((s, r) => s + r.impressions, 0) }))
        .sort((a, b) => b.totalImpr - a.totalImpr)
        .slice(0, 200);
      gscSection = "\nDATA GSC (сторінка [покази]: топ запити):\n" + pages.map(p => {
        const topQ = p.rows.sort((a, b) => b.impressions - a.impressions).slice(0, 5)
          .map(r => `${r.query} (${r.impressions} пок., поз. ${r.position})`).join(", ");
        return `${p.page} [${p.totalImpr} пок.]: ${topQ}`;
      }).join("\n");
    }

    // Serpstat domain keywords
    let serpstatSection = "";
    if (serpstatKws.length) {
      serpstatSection = "\nSERPSTAT КЛЮЧІ ДОМЕНУ (не покриті структурою):\n" + serpstatKws.slice(0, 200).map(k =>
        `"${k.keyword}" — частотність: ${k.region_queries_count || k.frequency || 0}, позиція: ${k.position || "?"}`
      ).join("\n");
    }

    // 3. Crawl competitor structures
    setAiProgress("Краулінг конкурентів...");
    let competitorSection = "";
    try {
      const compResp = await apiFetch(`/api/projects/${activeId}/structure/crawl-competitors`, { method: "POST" });
      const compData = await compResp.json();
      if (compData.competitors?.length) {
        competitorSection = "\nСТРУКТУРИ КОНКУРЕНТІВ:\n";
        for (const comp of compData.competitors) {
          if (comp.error || !comp.tree) continue;
          competitorSection += `\n--- ${comp.domain} (${comp.totalPages} сторінок) ---\n`;
          const flatComp = (node, depth = 0) => {
            let out = "";
            if (node.name && depth > 0) out += "  ".repeat(depth - 1) + node.name + (node.url ? ` (${node.url})` : "") + "\n";
            (node.children || []).forEach(c => { out += flatComp(c, depth + 1); });
            return out;
          };
          competitorSection += flatComp(comp.tree);
        }
      }
    } catch {}

    const prompt = `Ти SEO-спеціаліст. Проаналізуй структуру сайту, семантичне ядро, дані GSC та Serpstat. Знайди ВСІ непокриті запити та запропонуй нові сторінки.${proj?.version ? `\nВерсія сайту: ${proj.version}.` : ""}

ПОТОЧНА СТРУКТУРА САЙТУ:
${treeText}
${clusterSection}${semSection}${gscSection}${serpstatSection}${competitorSection}

ЗАДАЧА: Знайди ВСІ запити та кластери які НЕ покриті поточною структурою. Порівняй з конкурентами — знайди що є у них і немає у нас. Запропонуй нові сторінки/категорії.

ДЖЕРЕЛА ДАНИХ ДЛЯ АНАЛІЗУ:
${clusters.length ? `- Семантичне ядро: ${clusters.length} кластерів` : ""}
${gscQueries.length ? `- GSC: ${gscQueries.length} запитів (реальний попит!)` : ""}
${serpstatKws.length ? `- Serpstat: ${serpstatKws.length} ключів домену` : ""}
${competitorSection ? `- Структури конкурентів (навігація + sitemap)` : ""}

ПРАВИЛА:
- Пропонуй тільки релевантні сторінки для цього типу сайту
- Вказуй точного батька з існуючої структури
- Кожен кластер/запит з частотністю 50+ має бути покритий
- НЕ пропонуй сторінки які вже існують
- Запити з GSC — найвищий пріоритет (реальний попит)
- Запити з Serpstat яких немає в структурі — нові можливості
- Ключі з семантичного ядра без відповідної сторінки — створити сторінку
- Групуй пропозиції по батьківській категорії
- Якщо є дані конкурентів — знайди ВСІ категорії/сторінки яких немає у нас але є у конкурентів
- Для кожної пропозиції на основі конкурента вкажи "Є у конкурента: domain.com"
- МАКСИМАЛЬНА кількість пропозицій

Ответь СТРОГО в JSON формате (без markdown, без \`\`\`):
[
{
  "type": "expand",
  "parent_path": "Точное название родительской категории из структуры",
  "new_pages": [
    {"name": "Название новой подстраницы", "reason": "Покрывает: ключ (частотность)", "keywords": [{"keyword": "ключ 1", "frequency": 100}, {"keyword": "ключ 2", "frequency": 50}]}
  ]
},
{
  "type": "new_section",
  "parent_path": "Корневая категория куда добавить (или пустая строка если в корень)",
  "new_pages": [
    {"name": "Название новой категории/страницы", "reason": "Покрывает: ключ (частотность)", "keywords": [{"keyword": "ключ 1", "frequency": 100}]}
  ]
}
]

ВАЖНО: Для каждой новой страницы обязательно укажи массив "keywords" — все ключевые слова из кластеров и GSC которые эта страница должна покрывать, с их частотностью/показами.

type="expand" — расширение существующего каталога новыми подстраницами
type="new_section" — создание полностью нового раздела/категории которого нет в структуре`;

    try {
      setAiProgress("Claude анализирует структуру и кластеры...");
      const _tkn = localStorage.getItem("metago_token");
      const response = await fetch("/api/claude/stream", {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(_tkn ? { Authorization: `Bearer ${_tkn}` } : {}) },
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 16000,
          messages: [{ role: "user", content: prompt }]
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullText = "";
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          const jsonStr = line.slice(6);
          if (jsonStr === "[DONE]") continue;
          try {
            const evt = JSON.parse(jsonStr);
            if (evt.type === "content_block_delta" && evt.delta?.text) {
              fullText += evt.delta.text;
              setAiProgress(`Генерация... ${fullText.length} символов`);
            } else if (evt.type === "error") {
              throw new Error(evt.error?.message || JSON.stringify(evt.error) || "Stream error");
            }
          } catch (parseErr) {
            if (parseErr.message !== "Stream error" && !parseErr.message?.includes("Stream") && !parseErr.message?.includes("Unexpected") ) {
              // not a JSON parse error — rethrow
              throw parseErr;
            }
            // Try parsing raw error from API
            if (jsonStr.includes('"error"')) {
              try { const e = JSON.parse(jsonStr); throw new Error(e.error?.message || e.error?.type || jsonStr); } catch(e2) { if (e2.message && !e2.message.includes("Unexpected")) throw e2; }
            }
          }
        }
      }

      const clean = fullText.replace(/```json|```/g, "").trim();
      const parsed = (() => {
        try { return JSON.parse(clean); } catch (e) { /* нижче — рятуємо обрізаний вивід */ }
        // AI-вивід обрізало (ліміт токенів) → зберігаємо всі ЗАВЕРШЕНІ елементи масиву.
        const s = clean.trim();
        if (s[0] !== "[") throw new Error("AI повернув некоректний JSON. Спробуйте ще раз.");
        let depth = 0, inStr = false, esc = false, lastGood = -1;
        for (let i = 0; i < s.length; i++) {
          const c = s[i];
          if (inStr) { if (esc) esc = false; else if (c === "\\") esc = true; else if (c === '"') inStr = false; continue; }
          if (c === '"') inStr = true;
          else if (c === "[" || c === "{") depth++;
          else if (c === "]" || c === "}") { depth--; if (depth === 1 && c === "}") lastGood = i; }
        }
        if (lastGood > 0) { try { return JSON.parse(s.slice(0, lastGood + 1) + "]"); } catch (e2) { /* fallthrough */ } }
        throw new Error("AI повернув неповний JSON (обрізано на " + clean.length + " симв.). Згенеруйте меншими частинами.");
      })();
      setSuggestions(parsed);
      // Auto-check all pages
      const allKeys = new Set();
      parsed.forEach((sg, gi) => sg.new_pages.forEach((_, pi) => allKeys.add(`${gi}-${pi}`)));
      setCheckedPages(allKeys);
      setAiProgress("");
    } catch (err) {
      setAiProgress(""); flash("Ошибка AI: " + err.message);
    }
    setAiLoading(false);
  };

  // Apply single suggestion group (mutates tree in-place, returns count)
  const applySuggestionMut = (treeCopy, sg) => {
    // Find parent node by name (recursive, multi-strategy)
    const findNode = (nodes, name) => {
      const low = name.toLowerCase().trim();
      // 1. Exact match
      for (const n of nodes) {
        if (n.name === name) return n;
        if (n.children?.length) { const f = findNode(n.children, name); if (f) return f; }
      }
      // 2. Case-insensitive match
      for (const n of nodes) {
        if (n.name.toLowerCase().trim() === low) return n;
        if (n.children?.length) { const f = findNode(n.children, name); if (f) return f; }
      }
      // 3. Includes match (name contains search or search contains name)
      for (const n of nodes) {
        const nlow = n.name.toLowerCase().trim();
        if (nlow.includes(low) || low.includes(nlow)) return n;
        if (n.children?.length) {
          for (const ch of n.children) {
            const chlow = ch.name.toLowerCase().trim();
            if (chlow.includes(low) || low.includes(chlow)) return ch;
          }
        }
      }
      return null;
    };
    // If parent_path is empty or type is new_section with no parent — add to root
    let parent;
    if (!sg.parent_path || sg.parent_path.trim() === "") {
      parent = treeCopy; // root node has .children
    } else {
      // Try full path, then last segment, then any segment
      let parentName = sg.parent_path;
      parent = findNode(treeCopy.children, parentName);
      if (!parent && parentName.includes(" > ")) {
        const segments = parentName.split(" > ").map(s => s.trim());
        for (let i = segments.length - 1; i >= 0 && !parent; i--) {
          parent = findNode(treeCopy.children, segments[i]);
        }
      }
    }
    if (!parent) {
      // Parent not found — silently add to root
      parent = treeCopy;
    }
    const children = parent.children || (parent.children = []);
    let added = 0;
    for (const pg of sg.new_pages) {
      if (children.find(c => c.name === pg.name)) continue;
      const base = (parent.url || "").replace(/https?:\/\/[^/]+/, "").replace(/\/?$/, "");
      const slug = toSlug(pg.name);
      children.push({ name: pg.name, url: base ? base + "/" + slug : "/" + slug, children: [], isNew: true, aiReason: pg.reason, keywords: pg.keywords || [] });
      added++;
    }
    return added;
  };

  // Apply only checked pages
  const applyChecked = () => {
    if (!suggestions || !tree || !checkedPages.size) return;
    try {
      const copy = JSON.parse(JSON.stringify(tree));
      let total = 0;
      let report = [];
      suggestions.forEach((sg, gi) => {
        const selectedPages = sg.new_pages.filter((_, pi) => checkedPages.has(`${gi}-${pi}`));
        if (!selectedPages.length) return;
        const filtered = { ...sg, new_pages: selectedPages };
        const added = applySuggestionMut(copy, filtered);
        total += added;
        if (added) report.push(`${sg.parent_path || "Корень"}: +${added}`);
      });
      // Collect new pages with keywords to add to clusters
      const newClusterPages = [];
      const collectNew = (nodes) => {
        (nodes || []).forEach(n => {
          if (n.isNew && n.keywords && n.keywords.length > 0 && !n._addedToClusters) {
            newClusterPages.push(n);
            n._addedToClusters = true;
          }
          collectNew(n.children);
        });
      };
      collectNew(copy.children);

      // Add new clusters to semantics
      if (newClusterPages.length > 0) {
        const curStore = getStore(activeId);
        const existingClusters = curStore.clusters || [];
        const existingRows = curStore.rows || [];
        const existingUrls = new Set(existingClusters.map(c => c.url));
        const newClusters = [];
        const newRows = [];
        for (const pg of newClusterPages) {
          const pgUrl = pg.url || "";
          if (existingUrls.has(pgUrl)) continue;
          const kws = (pg.keywords || []).map(k => ({ keyword: k.keyword, frequency: k.frequency || 0 }));
          kws.sort((a, b) => b.frequency - a.frequency);
          newClusters.push({
            id: uid(), url: pgUrl, keywords: kws.slice(0, 20), allCount: kws.length,
            hfKeyword: kws[0]?.keyword || "", hfFreq: kws[0]?.frequency || 0,
            status: "EXPANSION", meta: null, issues: [], error: ""
          });
          kws.forEach(k => newRows.push({ keyword: k.keyword, frequency: k.frequency, url: pgUrl }));
        }
        if (newClusters.length > 0) {
          const allClusters = [...existingClusters, ...newClusters];
          const allRows = [...existingRows, ...newRows];
          setStore(activeId, { ...curStore, clusters: allClusters, rows: allRows, structure: copy });
          saveClusters(activeId, allClusters);
        } else {
          setStore(activeId, { ...getStore(activeId), structure: copy });
        }
      } else {
        setStore(activeId, { ...getStore(activeId), structure: copy });
      }

      // Save structure
      saveStructure(activeId, copy);
      // Expand all nodes
      const ae = {};
      const expandAll = (nodes, pfx) => {
        (nodes || []).forEach((n, i) => {
          const p = pfx !== undefined ? pfx + "/" + i : String(i);
          if (n.children?.length) { ae[p] = true; expandAll(n.children, p); }
        });
      };
      expandAll(copy.children, undefined);
      // Update local state
      setTree(copy);
      recalcStats(copy);
      setExpMap(ae);
      setSuggestions(null);
      setCheckedPages(new Set());
      setVer(v => v + 1);
      if (total > 0) {
        setApplyReport(report);
      }
    } catch (err) { flash("Ошибка: " + err.message); }
  };

  const toggleCheck = (key) => setCheckedPages(prev => {
    const next = new Set(prev);
    next.has(key) ? next.delete(key) : next.add(key);
    return next;
  });
  const toggleGroupCheck = (gi, pages) => {
    const keys = pages.map((_, pi) => `${gi}-${pi}`);
    const allOn = keys.every(k => checkedPages.has(k));
    setCheckedPages(prev => {
      const next = new Set(prev);
      keys.forEach(k => allOn ? next.delete(k) : next.add(k));
      return next;
    });
  };
  const toggleAllChecked = () => {
    if (!suggestions) return;
    const all = [];
    suggestions.forEach((sg, gi) => sg.new_pages.forEach((_, pi) => all.push(`${gi}-${pi}`)));
    const allOn = all.every(k => checkedPages.has(k));
    setCheckedPages(allOn ? new Set() : new Set(all));
  };

  // Toggle keywords panel — check node.keywords first, then URL match
  const toggleKeywords = (path, node) => {
    setKwOpen(prev => {
      if (prev[path]) return { ...prev, [path]: null };
      // 1. New pages have keywords from Claude
      if (node.keywords && node.keywords.length > 0) {
        return { ...prev, [path]: node.keywords };
      }
      // 2. Existing pages — match by URL to clusters from semantics
      const store = getStore(activeId);
      const clusters = store.clusters || [];
      if (!node.url || !clusters.length) return { ...prev, [path]: [] };
      const norm = (u) => (u || "").replace(/https?:\/\/[^/]+/, "").replace(/\/+$/, "").toLowerCase();
      const nodeNorm = norm(node.url);
      const match = clusters.find(c => norm(c.url) === nodeNorm);
      return { ...prev, [path]: match ? (match.keywords || []) : [] };
    });
  };

  // Node component
  const Node = ({ node, depth, path, isLast }) => {
    const hasK = node.children && node.children.length > 0;
    const isOpen = !!expMap[path];
    const isAdd = addPath === path;
    const cls = ["#6366f1", "#8b5cf6", "#a855f7", "#c084fc", "#d8b4fe", "#e9d5ff"];
    const c = cls[Math.min(depth, cls.length - 1)];
    const shortUrl = node.url ? node.url.replace(/https?:\/\/[^/]+/, "") : "";
    const nodeKw = kwOpen[path]; // null/undefined = closed, [] = no match, [...] = keywords

    return (
      <div style={{ marginLeft: depth === 0 ? 0 : 24, position: "relative" }}>
        {depth > 0 && <div style={{ position: "absolute", left: -14, top: 0, bottom: isLast ? 14 : 0, width: 2, background: dark ? "#2a2a3a" : "#e0e0e0" }} />}
        {depth > 0 && <div style={{ position: "absolute", left: -14, top: 13, width: 12, height: 2, background: dark ? "#2a2a3a" : "#e0e0e0" }} />}

        <div style={{ display: "flex", alignItems: "center", gap: 5, padding: "3px 6px", borderRadius: 6, marginBottom: 1 }}>
          {hasK ? (
            <span onClick={() => doToggle(path)} style={{ fontSize: 9, color: c, width: 14, textAlign: "center", fontWeight: 700, cursor: "pointer" }}>{isOpen ? "▼" : "▶"}</span>
          ) : (
            <span style={{ width: 14, textAlign: "center", fontSize: 7, color: t.textMuted }}>●</span>
          )}
          <div style={{ width: 8, height: 8, borderRadius: 4, background: node.isNew ? "#22c55e" : c, flexShrink: 0 }} />
          <span style={{ fontSize: 12, fontWeight: hasK ? 600 : 400, color: node.isNew ? "#22c55e" : t.text }}>{node.name}</span>
          {node.isNew && <span style={{ fontSize: 9, background: "#22c55e", color: "#fff", padding: "0 5px", borderRadius: 6, fontWeight: 600 }}>NEW</span>}
          <span onClick={e => { e.stopPropagation(); toggleKeywords(path, node); }}
            style={{ fontSize: 9, background: nodeKw ? "#f59e0b" : (dark ? "#333" : "#ddd"), color: nodeKw ? "#fff" : t.textMuted, padding: "0 5px", borderRadius: 6, fontWeight: 600, cursor: "pointer" }}
            title="Показать ключевые слова кластера">
            🔑
          </span>
          {node.aiReason && <span style={{ fontSize: 9, color: t.textMuted, maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={node.aiReason}>💡 {node.aiReason}</span>}
          {shortUrl && <span style={{ fontSize: 9, color: t.textMuted, opacity: 0.6, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shortUrl}</span>}
          {node.url && (userRole === "admin" || userRole === "user") && <span onClick={e => { e.stopPropagation(); openRename(node.url); }} title="Змінити URL сторінки (каскадно)" style={{ fontSize: 11, cursor: "pointer", opacity: 0.5, marginLeft: 1 }}>✎</span>}
          {hasK && <span style={{ fontSize: 9, background: c, color: "#fff", padding: "0 5px", borderRadius: 6, fontWeight: 600 }}>{node.children.length}</span>}
          <span onClick={e => { e.stopPropagation(); setAddPath(isAdd ? null : path); setAddText(""); }}
            style={{ fontSize: 15, color: isAdd ? "#dc2626" : "#22c55e", cursor: "pointer", marginLeft: 2, fontWeight: 700, lineHeight: 1 }}
            title="Добавить подстраницы">{isAdd ? "✕" : "＋"}</span>
        </div>

        {isAdd && (
          <div style={{ marginLeft: 38, marginBottom: 6, padding: 10, background: dark ? "#1a1a28" : "#f0fdf4", border: `1px solid ${dark ? "#2a3a2a" : "#bbf7d0"}`, borderRadius: 8 }}>
            <p style={{ fontSize: 11, fontWeight: 600, color: "#16a34a", marginBottom: 4 }}>Новые подстраницы (по одной на строку):</p>
            <textarea value={addText} onChange={e => setAddText(e.target.value)} rows={4}
              placeholder={"Подкатегория 1\nПодкатегория 2\nПодкатегория 3"}
              style={{ ...inp, fontSize: 12, resize: "vertical", background: dark ? "#0f0f14" : "#fff" }} autoFocus />
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <button style={{ ...btnP, fontSize: 11, padding: "4px 12px" }} onClick={addChildren}>✓ Добавить</button>
              <button style={btnSm} onClick={() => { setAddPath(null); setAddText(""); }}>Отмена</button>
            </div>
          </div>
        )}

        {nodeKw && nodeKw.length > 0 && (
          <div style={{ marginLeft: 38, marginBottom: 6, padding: 8, background: dark ? "#1a1a20" : "#fffbeb", border: `1px solid ${dark ? "#3a3520" : "#fde68a"}`, borderRadius: 8 }}>
            <div style={{ fontSize: 10, fontWeight: 600, color: "#f59e0b", marginBottom: 4 }}>Ключевые слова кластера ({nodeKw.length}):</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
              {nodeKw.map((kw, ki) => (
                <span key={ki} style={{ fontSize: 10, padding: "1px 6px", borderRadius: 4, background: dark ? "#2a2a20" : "#fef3c7", color: dark ? "#fbbf24" : "#92400e", whiteSpace: "nowrap" }}>
                  {kw.keyword} <b style={{ opacity: 0.7 }}>({kw.frequency})</b>
                </span>
              ))}
            </div>
          </div>
        )}
        {nodeKw && nodeKw.length === 0 && (
          <div style={{ marginLeft: 38, marginBottom: 6, padding: 6, fontSize: 10, color: t.textMuted, fontStyle: "italic" }}>
            Кластер не найден для этой страницы
          </div>
        )}

        {hasK && isOpen && node.children.map((ch, i) => (
          <Node key={`${path}/${i}-${ver}`} node={ch} depth={depth + 1} path={path + "/" + i} isLast={i === node.children.length - 1} />
        ))}
      </div>
    );
  };

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>🌳 Расширение структуры</h2>
      <p style={{ ...muted, marginBottom: 16 }}>Загрузите CSV структуры сайта, добавляйте новые страницы через ＋</p>

      <div style={{ ...card, textAlign: "center", padding: tree ? 14 : 24 }}>
        {!tree ? (
          <div>
            <div style={{ display: "flex", gap: 12, justifyContent: "center", marginBottom: showPaste ? 12 : 0 }}>
              <div style={{ border: `2px dashed ${dark ? "#444" : "#ccc"}`, borderRadius: 12, padding: "20px 24px", cursor: "pointer", background: dark ? "#151520" : "#fafafa", flex: 1, maxWidth: 300 }} onClick={() => fRef.current?.click()}>
                <div style={{ fontSize: 28 }}>📄</div>
                <p style={{ fontWeight: 500, marginTop: 4 }}>Завантажити CSV/TSV файл</p>
                <p style={muted}>Назва в колонці N (рівень), URL в колонці N+1</p>
              </div>
              <div style={{ border: `2px dashed ${showPaste ? "#6366f1" : (dark ? "#444" : "#ccc")}`, borderRadius: 12, padding: "20px 24px", cursor: "pointer", background: dark ? "#151520" : "#fafafa", flex: 1, maxWidth: 300 }} onClick={() => setShowPaste(!showPaste)}>
                <div style={{ fontSize: 28 }}>📋</div>
                <p style={{ fontWeight: 500, marginTop: 4 }}>Вставити з таблиці</p>
                <p style={muted}>Скопіюйте структуру з Excel / Google Sheets</p>
              </div>
            </div>
            {showPaste && (
              <div style={{ marginTop: 12, textAlign: "left" }}>
                <textarea value={pasteText} onChange={e => setPasteText(e.target.value)} rows={10}
                  placeholder={"Скопіюйте рядки з таблиці та вставте сюди (Ctrl+V).\nФормат: назва в колонці рівня, URL в наступній колонці.\n\nКатегорія 1\thttps://site.com/cat1\n\tПідкатегорія 1\thttps://site.com/cat1/sub1\n\tПідкатегорія 2\thttps://site.com/cat1/sub2\nКатегорія 2\thttps://site.com/cat2"}
                  style={{ width: "100%", padding: 10, fontSize: 12, fontFamily: "monospace", borderRadius: 8, border: `1px solid ${dark ? "#333" : "#ccc"}`, background: dark ? "#0f0f14" : "#fff", color: dark ? "#e0e0e0" : "#333", resize: "vertical", boxSizing: "border-box" }} autoFocus />
                <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "center" }}>
                  <button style={{ ...btnP, fontSize: 12 }} onClick={handlePaste} disabled={!pasteText.trim()}>Завантажити</button>
                  <button style={btnSm} onClick={() => { setShowPaste(false); setPasteText(""); }}>Скасувати</button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            <span style={{ fontSize: 12, color: "#16a34a" }}>✓ Загружено</span>
            <button style={btnSm} onClick={() => fRef.current?.click()}>📄 Перезагрузить</button>
            <button style={btnSm} onClick={() => setShowPaste(!showPaste)}>📋 Вставити з таблиці</button>
            <button style={btnSm} onClick={exportCSV}>⬇ CSV (с новыми)</button>
            {(userRole === "admin" || userRole === "user") && <button style={btnSm} onClick={loadHist} disabled={histBusy}>{histBusy ? "⏳" : "📜 Історія змін URL"}</button>}
            <button style={{ ...btnP, fontSize: 12 }} onClick={suggestExpansions} disabled={aiLoading}>
              {aiLoading ? "⏳ Анализ..." : "🤖 Предложить расширения"}
            </button>
            <button style={{ ...btnSm, color: "#dc2626", borderColor: "#dc2626" }} onClick={() => {
              if (!window.confirm("Видалити всю структуру? Це незворотня дія.")) return;
              setTree(null); setStats(null); setExpMap({}); setSuggestions(null);
              setStore(activeId, { ...getStore(activeId), structure: null });
              saveStructure(activeId, null);
              flash("Структуру видалено");
            }}>🗑 Видалити</button>
          </div>
          {showPaste && (
            <div style={{ marginTop: 12, textAlign: "left" }}>
              <textarea value={pasteText} onChange={e => setPasteText(e.target.value)} rows={10}
                placeholder={"Скопіюйте рядки з таблиці та вставте сюди (Ctrl+V).\nФормат: назва в колонці рівня, URL в наступній колонці.\n\nКатегорія 1\thttps://site.com/cat1\n\tПідкатегорія 1\thttps://site.com/cat1/sub1\n\tПідкатегорія 2\thttps://site.com/cat1/sub2\nКатегорія 2\thttps://site.com/cat2"}
                style={{ width: "100%", padding: 10, fontSize: 12, fontFamily: "monospace", borderRadius: 8, border: `1px solid ${dark ? "#333" : "#ccc"}`, background: dark ? "#0f0f14" : "#fff", color: dark ? "#e0e0e0" : "#333", resize: "vertical", boxSizing: "border-box" }} autoFocus />
              <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "center" }}>
                <button style={{ ...btnP, fontSize: 12 }} onClick={handlePaste} disabled={!pasteText.trim()}>Завантажити</button>
                <button style={btnSm} onClick={() => { setShowPaste(false); setPasteText(""); }}>Скасувати</button>
              </div>
            </div>
          )}
          </div>
        )}
        <input ref={fRef} type="file" accept=".csv,.tsv,.txt" hidden onChange={e => { if (e.target.files[0]) handleFile(e.target.files[0]); e.target.value = ""; }} />
        {error && <p style={{ color: "#dc2626", marginTop: 8, fontSize: 13 }}>❌ {error}</p>}
      </div>

      {/* Competitors block */}
      {tree && (() => {
        const compList = (proj.competitors || []).filter(Boolean);
        return (
          <div style={{ ...card, padding: "12px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 14 }}>🏆</span>
              <span style={{ fontSize: 13, fontWeight: 700 }}>Конкуренти для gap-аналізу</span>
              <span style={{ fontSize: 11, color: t.textMuted }}>— AI порівняє їх структуру з вашою при розширенні</span>
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
              <textarea
                value={(proj.competitors || []).join("\n")}
                onChange={e => {
                  const l = e.target.value.split("\n").map(s => s.trim());
                  setProjects(ps => ps.map(p => p.id === activeId ? { ...p, competitors: l.filter(Boolean) } : p));
                }}
                onBlur={e => {
                  const l = e.target.value.split("\n").map(s => s.trim()).filter(Boolean);
                  apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ competitors: l }) }).catch(() => {});
                }}
                placeholder={"competitor1.com\ncompetitor2.com\ncompetitor3.com"}
                rows={2}
                style={{ ...inp, flex: 1, fontSize: 12, fontFamily: "monospace", resize: "vertical", padding: "6px 10px" }}
              />
              {compList.length > 0 && (
                <span style={{ fontSize: 11, padding: "4px 10px", borderRadius: 6, background: "rgba(16,185,129,0.1)", color: "#10b981", fontWeight: 700, whiteSpace: "nowrap" }}>
                  {compList.length} конкурентів
                </span>
              )}
            </div>
          </div>
        );
      })()}

      {/* AI Progress */}
      {aiLoading && aiProgress && (
        <div style={{ ...card, padding: 14, textAlign: "center", background: dark ? "#151530" : "#eef2ff" }}>
          <div style={{ fontSize: 13, color: "#6366f1", fontWeight: 500 }}>⏳ {aiProgress}</div>
        </div>
      )}

      {/* AI Suggestions */}
      {suggestions && suggestions.length > 0 && (() => {
        const totalPages = suggestions.reduce((s, g) => s + g.new_pages.length, 0);
        const expandGroups = suggestions.filter(s => s.type === "expand" || !s.type);
        const newGroups = suggestions.filter(s => s.type === "new_section");
        return (
          <div style={{ ...card, padding: 14, border: `2px solid ${dark ? "#4f46e5" : "#818cf8"}`, background: dark ? "#151530" : "#eef2ff" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              <p style={{ ...stitle, margin: 0, color: "#6366f1" }}>Предложения ({totalPages} страниц, выбрано {checkedPages.size})</p>
              <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
                <button style={btnSm} onClick={toggleAllChecked}>
                  {checkedPages.size === totalPages ? "Снять все" : "Выбрать все"}
                </button>
                <button style={{ ...btnP, fontSize: 11, padding: "4px 14px" }} onClick={applyChecked} disabled={!checkedPages.size}>
                  Добавить выбранные ({checkedPages.size})
                </button>
                <button style={btnSm} onClick={exportSuggestionsCSV}>⬇ CSV</button>
                <button style={btnSm} onClick={() => { setSuggestions(null); setCheckedPages(new Set()); }}>Закрыть</button>
              </div>
            </div>

            {expandGroups.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#6366f1", marginBottom: 8, padding: "6px 0", borderBottom: `1px solid ${dark ? "#333" : "#c7d2fe"}` }}>
                  Расширение существующих каталогов
                </div>
                {expandGroups.map((sg) => {
                  const gi = suggestions.indexOf(sg);
                  return (
                    <div key={gi} style={{ marginBottom: 8, padding: 10, background: dark ? "#1a1a2e" : "#f8fafc", borderRadius: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                        <input type="checkbox"
                          checked={sg.new_pages.every((_, pi) => checkedPages.has(`${gi}-${pi}`))}
                          onChange={() => toggleGroupCheck(gi, sg.new_pages)}
                          style={{ cursor: "pointer", accentColor: "#6366f1" }}
                        />
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#6366f1" }}>{sg.parent_path}</span>
                        <span style={{ fontSize: 10, color: t.textMuted }}>({sg.new_pages.length} стр.)</span>
                      </div>
                      {sg.new_pages.map((pg, pi) => (
                        <div key={pi} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "4px 0 4px 24px" }}>
                          <input type="checkbox"
                            checked={checkedPages.has(`${gi}-${pi}`)}
                            onChange={() => toggleCheck(`${gi}-${pi}`)}
                            style={{ cursor: "pointer", marginTop: 2, accentColor: "#6366f1", flexShrink: 0 }}
                          />
                          <div>
                            <span style={{ fontSize: 12, fontWeight: 600, color: checkedPages.has(`${gi}-${pi}`) ? "#22c55e" : t.text }}>{pg.name}</span>
                            <span style={{ color: t.textMuted, marginLeft: 8, fontSize: 10 }}>{pg.reason}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}

            {newGroups.length > 0 && (
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#22c55e", marginBottom: 8, padding: "6px 0", borderBottom: `1px solid ${dark ? "#333" : "#bbf7d0"}` }}>
                  Новые разделы / страницы
                </div>
                {newGroups.map((sg) => {
                  const gi = suggestions.indexOf(sg);
                  return (
                    <div key={gi} style={{ marginBottom: 8, padding: 10, background: dark ? "#0f1f15" : "#f0fdf4", borderRadius: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                        <input type="checkbox"
                          checked={sg.new_pages.every((_, pi) => checkedPages.has(`${gi}-${pi}`))}
                          onChange={() => toggleGroupCheck(gi, sg.new_pages)}
                          style={{ cursor: "pointer", accentColor: "#22c55e" }}
                        />
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#22c55e" }}>{sg.parent_path || "В корень структуры"}</span>
                        <span style={{ fontSize: 10, color: t.textMuted }}>({sg.new_pages.length} стр.)</span>
                      </div>
                      {sg.new_pages.map((pg, pi) => (
                        <div key={pi} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "4px 0 4px 24px" }}>
                          <input type="checkbox"
                            checked={checkedPages.has(`${gi}-${pi}`)}
                            onChange={() => toggleCheck(`${gi}-${pi}`)}
                            style={{ cursor: "pointer", marginTop: 2, accentColor: "#22c55e", flexShrink: 0 }}
                          />
                          <div>
                            <span style={{ fontSize: 12, fontWeight: 600, color: checkedPages.has(`${gi}-${pi}`) ? "#22c55e" : t.text }}>{pg.name}</span>
                            <span style={{ color: t.textMuted, marginLeft: 8, fontSize: 10 }}>{pg.reason}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })()}

      {/* Apply Report */}
      {applyReport && applyReport.length > 0 && (
        <div style={{ ...card, padding: 14, border: `2px solid ${dark ? "#166534" : "#86efac"}`, background: dark ? "#0f1f15" : "#f0fdf4" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#22c55e" }}>✅ Добавлено в структуру:</span>
            <button style={{ ...btnSm, marginLeft: "auto" }} onClick={() => setApplyReport(null)}>✕</button>
          </div>
          {applyReport.map((line, i) => (
            <div key={i} style={{ fontSize: 12, padding: "2px 0", color: dark ? "#bbf7d0" : "#166534" }}>📁 {line}</div>
          ))}
          <p style={{ fontSize: 11, color: t.textMuted, marginTop: 8 }}>Новые страницы отмечены <span style={{ color: "#22c55e", fontWeight: 700 }}>зелёным</span> в дереве ниже ↓</p>
        </div>
      )}

      {tree && stats && (
        <div style={card}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
            <p style={{ ...stitle, margin: 0 }}>Дерево каталогов</p>
            <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
              <button style={btnSm} onClick={doExpandAll}>⊞ Развернуть</button>
              <button style={btnSm} onClick={doCollapseAll}>⊟ Свернуть</button>
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, marginBottom: 8, flexWrap: "wrap", fontSize: 11 }}>
            {["Ур. 1", "Ур. 2", "Ур. 3", "Ур. 4", "Ур. 5+"].map((l, i) => (
              <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
                <span style={{ width: 7, height: 7, borderRadius: 4, background: ["#6366f1", "#8b5cf6", "#a855f7", "#c084fc", "#d8b4fe"][i], display: "inline-block" }} />
                <span style={{ color: t.textMuted }}>{l}</span>
              </span>
            ))}
            <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
              <span style={{ width: 7, height: 7, borderRadius: 4, background: "#22c55e", display: "inline-block" }} />
              <span style={{ color: "#22c55e" }}>Новые</span>
            </span>
          </div>

          <div style={{ overflowX: "auto", padding: "4px 0", maxHeight: "70vh", overflowY: "auto" }}>
            {tree.children.map((nd, i) => (
              <Node key={`${i}-${ver}`} node={nd} depth={0} path={String(i)} isLast={i === tree.children.length - 1} />
            ))}
          </div>

          <div style={{ marginTop: 12, padding: 10, background: dark ? "#151520" : "#f9fafb", borderRadius: 8, display: "flex", gap: 14, fontSize: 12, flexWrap: "wrap" }}>
            <span>📊 Всего: <b>{stats.total}</b></span>
            <span>📁 Категорий: <b>{stats.top}</b></span>
            <span>📏 Глубина: <b>{stats.depth}</b></span>
          </div>
        </div>
      )}

      {hist && (
        <div onClick={() => setHist(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: 860, maxWidth: "100%", maxHeight: "86vh", overflowY: "auto", background: dark ? "#17171f" : "#fff", border: `1px solid ${t.border}`, borderRadius: 14, padding: 22 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: t.text }}>📜 Історія змін URL</div>
              <button onClick={() => setHist(null)} style={{ ...btnG, padding: "4px 12px" }}>Закрити</button>
            </div>
            <div style={{ fontSize: 12, color: t.textMuted, marginBottom: 14 }}>Журнал каскадних перейменувань сторінок цього проєкту (останні 500).</div>
            {hist.length === 0 ? (
              <div style={{ fontSize: 13, color: t.textMuted, padding: "24px 0", textAlign: "center" }}>Поки що жодної зміни URL не зафіксовано.</div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <thead>
                    <tr>
                      <th style={{ ...th, textAlign: "left", whiteSpace: "nowrap" }}>Дата</th>
                      <th style={{ ...th, textAlign: "left" }}>Було → Стало</th>
                      <th style={{ ...th, textAlign: "left" }}>Режим</th>
                      <th style={{ ...th, textAlign: "left" }}>Оновлено</th>
                      <th style={{ ...th, textAlign: "left" }}>Хто</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hist.map(h => {
                      const touched = Object.entries(h.report || {}).filter(([, v]) => Number(v) > 0);
                      const total = touched.reduce((s, [, v]) => s + Number(v), 0);
                      const d = new Date(h.created_at);
                      return (
                        <tr key={h.id} style={{ borderTop: `1px solid ${t.border}` }}>
                          <td style={{ ...td, whiteSpace: "nowrap", verticalAlign: "top" }}>{isNaN(d) ? "" : d.toLocaleString("uk-UA")}</td>
                          <td style={{ ...td, verticalAlign: "top" }}>
                            <div style={{ color: "#dc2626", wordBreak: "break-all" }}>{rnStrip(h.old_url)}</div>
                            <div style={{ color: "#16a34a", wordBreak: "break-all" }}>→ {rnStrip(h.new_url)}</div>
                          </td>
                          <td style={{ ...td, verticalAlign: "top", whiteSpace: "nowrap" }}>{h.mode === "prefix" ? "гілка /*" : "одна"}{h.republished ? " · ↻" : ""}</td>
                          <td style={{ ...td, verticalAlign: "top" }} title={touched.map(([k, v]) => `${k}: ${v}`).join(" · ")}>
                            <b>{total}</b>{touched.length ? <span style={{ color: t.textMuted }}> ({touched.map(([k, v]) => `${k}:${v}`).join(", ")})</span> : null}
                          </td>
                          <td style={{ ...td, verticalAlign: "top", whiteSpace: "nowrap" }}>{h.changed_by || "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {rn && (
        <div onClick={() => !rn.busy && setRn(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: 560, maxWidth: "100%", background: dark ? "#17171f" : "#fff", border: `1px solid ${t.border}`, borderRadius: 14, padding: 22 }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 4, color: t.text }}>Змінити URL сторінки</div>
            <div style={{ fontSize: 12, color: t.textMuted, marginBottom: 14 }}>Каскадно оновить: семантику, структуру, кокон (+ посилання на цю сторінку в інших блоках), тексти (+ посилання всередині), мету, schema, позиції.</div>
            <label style={{ fontSize: 11, fontWeight: 600, color: t.textMuted }}>Старий URL</label>
            <input value={rn.oldUrl} onChange={e => setRn(r => ({ ...r, oldUrl: e.target.value, preview: null }))} style={{ width: "100%", padding: "8px 10px", margin: "3px 0 10px", borderRadius: 8, border: `1px solid ${t.border}`, background: dark ? "#0f0f14" : "#fff", color: t.text, boxSizing: "border-box", fontSize: 13 }} />
            <label style={{ fontSize: 11, fontWeight: 600, color: t.textMuted }}>Новий URL</label>
            <input value={rn.newUrl} onChange={e => setRn(r => ({ ...r, newUrl: e.target.value, preview: null }))} placeholder="https://..." style={{ width: "100%", padding: "8px 10px", margin: "3px 0 10px", borderRadius: 8, border: `1px solid #6366f1`, background: dark ? "#0f0f14" : "#fff", color: t.text, boxSizing: "border-box", fontSize: 13 }} />
            <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12, color: t.text, marginBottom: 8, cursor: "pointer" }}>
              <input type="checkbox" checked={rn.mode === "prefix"} onChange={e => setRn(r => ({ ...r, mode: e.target.checked ? "prefix" : "single", preview: null }))} />
              Масова заміна: оновити й усі дочірні сторінки (гілку <code>{rnStrip(rn.oldUrl)}/*</code>)
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12, color: t.text, marginBottom: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={rn.republish} onChange={e => setRn(r => ({ ...r, republish: e.target.checked }))} />
              Одразу переопублікувати на сайт (SDK)
            </label>
            {rn.preview && (
              <div style={{ background: dark ? "#0f0f14" : "#f8f9fb", border: `1px solid ${t.border}`, borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 11.5, color: t.text }}>
                <b>Буде оновлено:</b> {Object.entries(rn.preview).filter(([, v]) => Number(v) > 0).map(([k, v]) => `${k}: ${v}`).join(" · ") || "нічого не знайдено (перевірте URL)"}
              </div>
            )}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setRn(null)} disabled={rn.busy} style={{ ...btnG, padding: "8px 14px" }}>Скасувати</button>
              <button onClick={rnPreview} disabled={rn.busy} style={{ ...btnG, padding: "8px 14px" }}>{rn.busy ? "…" : "Перевірити"}</button>
              <button onClick={rnApply} disabled={rn.busy || rnStrip(rn.oldUrl) === rnStrip(rn.newUrl)} style={{ ...btnP, padding: "8px 16px", opacity: (rn.busy || rnStrip(rn.oldUrl) === rnStrip(rn.newUrl)) ? 0.6 : 1 }}>{rn.busy ? "Застосовую…" : "Змінити"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};





// ═══ CLUSTERER VIEW ═══
